// Where the page lands after a navigation, like a browser would: back and forward
// return to where you were; an address with a #section (the How To guide's
// contents, or a link to one of its sections) lands on that section, just below
// the app bar, smoothly when it is the page you are already on; anything else
// starts at the top.
//
// The section is looked for on the next tick, once the page has rendered it.

// The app bar's height, so a section's heading is not hidden under it.
export const APP_BAR_OFFSET = 80

export default function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) return savedPosition
  if (to.hash) {
    return new Promise((resolve) =>
      setTimeout(() =>
        resolve({
          el: to.hash,
          top: APP_BAR_OFFSET,
          behavior: to.path === from.path ? 'smooth' : 'auto',
        })
      )
    )
  }
  return { top: 0, left: 0 }
}
